import { apiRequest } from '@/serves/http'
import locale from '@/locales/index'
import { Message} from 'element-ui'
export const joinSchool = (pathName) => {
  return new Promise((resolve, reject) => {
      let pathNameArr = pathName.split('/')
      let len = pathNameArr.length
      let inviteCode = pathNameArr[len - 1]
        apiRequest
        .get(`${window.ApiPath.join_school_by_code}?invite_code=${inviteCode}`)
        .then((res) => {
          if (res?.errcode == 0) {
            Message({
              type: 'success',
              message: locale.t('batch_success'),
            })
            resolve()
          } else {
            Message({
              type: 'error',
              message: res?.errmsg,
            })
            reject(res?.errmsg)
          }
        }).catch((err) => { 
          Message({
            type: 'error',
            message: err,
          })
           reject(err)
        })
  }) 
}